export default __webpack_public_path__ + "static/media/rw-h3.d3450c70.jpg";